import React from "react";
import Header from "./components/Header";
import About from "./components/About";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Awards from "./components/Awards";
import Publications from "./components/Publications";
import Miscellaneous from "./components/Miscellaneous";
import Footer from "./components/Footer";
import ChatBox from "./components/ChatBox";

const sections = [
  { Component: About, bg: "bg-gray-50" },
  { Component: Education, bg: "bg-white" },
  { Component: Experience, bg: "bg-gray-50" },
  { Component: Publications, bg: "bg-white" },
  { Component: Projects, bg: "bg-gray-50" },
  { Component: Skills, bg: "bg-white" },
  { Component: Awards, bg: "bg-gray-50" },
  { Component: Miscellaneous, bg: "bg-white" },
];

export default function App() {
  return (
    <>
      <Header />
      {sections.map(({ Component, bg }, index) => (
          <Component sectionBg={bg} key={index}/>
      ))}
      <Footer />
      <ChatBox /> {/* Floating AI Chatbox */}
    </>
  );
}
